export const filterArrayByOptions = (array: any[], options: string[]) => {
  const [port, origin, status, product] = options;
  return array.filter(row => {
    return (!port || row?.port?.name === port) &&
      (!origin || row?.port?.country?.name === origin) &&
      (!product || row.product?.name === product) &&
      (!status || (() => {
        const [siteName, systemName, statusName] = status.split("-");
        return row.systems.find((systemStatus) => {
          const {system, status} = systemStatus;
          return system.site.name === siteName && system.name === systemName && status === statusName;
        });
      })());
  });
};